import { useState } from "react";
import MainLayout from "./MainLayout";
import { Mail, Loader } from "lucide-react";
import apiClient from "../services/axiosInterceptor";
import { toast } from "react-toastify";

const ContactUs = ({ isInDashboard = false }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await apiClient.post("/contact", formData);
      toast.success(response.data.message || "Thank you for your message!");
      setFormData({ full_name: "", email: "", message: "" });
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const content = (
    <main className={`w-full max-w-7xl mx-auto flex flex-col items-center text-center px-6 md:px-12 space-y-12 pb-24 ${isInDashboard ? "pt-10" : "pt-32"}`}>
        <div className="space-y-4">
          <h1 className="text-5xl md:text-7xl font-extrabold text-gray-200 leading-tight">
            Contact Us
          </h1>
          <p className="text-xl text-gray-400">
            We'd love to hear from you. Reach out with any questions.
          </p>
        </div>

        <div className="flex items-center gap-3 rounded-full bg-gray-800/50 px-6 py-3 border border-white/10">
          <Mail className="w-6 h-6 text-purple-400" />
          <a
            href="mailto:info@intelquantai.com"
            className="text-lg text-gray-300 hover:text-white"
          >
            info@intelquantai.com
          </a>
        </div>

        <form onSubmit={handleSubmit} className="w-full max-w-lg space-y-6 text-left">
          <div>
            <label htmlFor="full_name" className="block text-sm font-medium text-gray-300 mb-2">
              Full Name
            </label>
            <input
              type="text"
              id="full_name"
              value={formData.full_name}
              onChange={handleChange}
              className="w-full px-4 py-3 rounded-lg bg-gray-800 border border-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-purple-500"
              placeholder="Your Name"
              required
            />
          </div>
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-2">
              Email Address
            </label>
            <input
              type="email"
              id="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full px-4 py-3 rounded-lg bg-gray-800 border border-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-purple-500"
              placeholder="you@example.com"
              required
            />
          </div>
          <div>
            <label htmlFor="message" className="block text-sm font-medium text-gray-300 mb-2">
              Message
            </label>
            <textarea
              id="message"
              rows="5"
              value={formData.message}
              onChange={handleChange}
              className="w-full px-4 py-3 rounded-lg bg-gray-800 border border-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-purple-500"
              placeholder="Your message..."
              required
            ></textarea>
          </div>
          <div>
            <button
              type="submit"
              disabled={loading}
              className={`w-full py-3 rounded-lg font-semibold transition bg-purple-500 hover:bg-purple-600 text-white flex items-center justify-center gap-2 ${loading ? "opacity-70 cursor-not-allowed" : ""}`}
            >
              {loading && <Loader className="animate-spin w-5 h-5" />}
              {loading ? "Sending..." : "Send Message"}
            </button>
          </div>
        </form>
      </main>
  );

  return isInDashboard ? content : <MainLayout>{content}</MainLayout>;
};

export default ContactUs;